import type { Ref } from 'vue'
import { computed } from 'vue'
import { useDateFormat } from '@/composables/useDateFormat'

export function useBlogPostDateFormatter(
    date: Readonly<Ref<Date | undefined | null>>
) {
    const { formatDate } = useDateFormat({
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    })

    const dateFormatted = computed(() => {
        if (!date.value) {
            return ''
        }
        return formatDate(date.value)
    })

    return { dateFormatted }
}
